import { request } from 'utils/request';
import { BidResponse } from './api';

import { errorFromException } from 'errors';

export const confirmBid = async (publicBidId: string) => {
  try {
    const { data } = await request.post<BidResponse>(
      Routes.confirm_api_internal_trade_bid_path(publicBidId),
    );
    return { data, error: undefined };
  } catch (e) {
    return errorFromException(e);
  }
};
